import { Link } from "react-router-dom";
import { RsuiteColumn } from "../common/DataTable.tsx";

interface RevivedPolicies {
  doc: string;
  policyNo: string;
  productName: string;
  revivedId: string;
  createdDate: string;
}

export const RevivedPoliciesColumns: RsuiteColumn<RevivedPolicies>[] = [
  { key: "rowNum", header: "SN" },
  { key: "createdDate", header: "Revival Date", width: 150 },
  { key: "policyNo", header: "Policy No", width: 120 },
  { key: "productName", header: "Product Name", width: 200 },
  {
    key: "",
    header: "Actions",
    width: 100,
    render: (row) => (
      <Link to={`/revived-policies/${row.revivedId}`}>View Details</Link>
    ),
  },
];
